import React from 'react';
import type { SelectChangeEvent } from '@mui/material';
import { Box } from '@mui/material';
import SelectBase from '../../../../primeX-underwriter/components/footer/SelectBase';
import type { PrimeXUnderwriteQuoteHandlers } from '../../views/underwriter/types';

const NyftzSelect = (props: Props) => {
  const handleChange = (e: SelectChangeEvent<any>) => {
    props.setGlobalValue({
      nyftzClassCode: {
        value: e.target.value,
      },
    });
  };

  const _options = props.options.map((opt) => {
    const [code, description] = opt.split('__');

    return {
      value: code,
      label: `${code} - ${description}`,
    };
  });

  return (
    <SelectBase
      options={_options ?? []}
      name={props.name}
      value={props.value}
      onChange={handleChange}
      renderValue={(selected) => (
        <Box
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: 150,
          }}
        >
          {_options.find((option) => option.value === selected)?.label ||
            (selected as string)}
        </Box>
      )}
    />
  );
};

export default NyftzSelect;

type Props = {
  options: string[];
  value: string;
  name: string;
  setGlobalValue: PrimeXUnderwriteQuoteHandlers['setGlobalValue'];
};
